<div style="display: flex;align-items: center;margin-bottom: 8px;">
    <div class="ui small header m-0" style="flex:1;">
        Kart Ayarları
    </div>
    <button nz-button
            (click)="nzModalRef.close()"
            nzType="text"
            nzShape="circle"
            nzSize="small"><nz-icon nzType="close" />
    </button>
</div>

<div class="kart-menu-grid">
    <button class="kart-menu-btn" (click)="nzModalRef.close({aksiyon: 'kopyala'})">
        <nz-icon nzType="copy" />
        <span>Kopyala</span>
    </button>

    <button class="kart-menu-btn" (click)="nzModalRef.close({aksiyon: 'bayrak'})">
        <nz-icon nzType="flag" />
        <span>Bayrak</span>
    </button>

    <button class="kart-menu-btn kart-menu-btn--tehlike"
            nz-popconfirm
            nzPopconfirmTitle="Kart sıfırlanacak, tüm içerik temizlenecek. Emin misiniz?"
            nzOkText="Evet, Sıfırla"
            nzCancelText="Vazgeç"
            nzOkDanger
            nzPopconfirmPlacement="top"
            (nzOnConfirm)="nzModalRef.close({aksiyon: 'sifirla'})">
        <nz-icon nzType="redo" />
        <span>Sıfırla</span>
    </button>

    <button class="kart-menu-btn" (click)="nzModalRef.close({aksiyon: 'taslakKaydet'})">
        <nz-icon nzType="save" />
        <span>Taslak Kaydet</span>
    </button>
</div>
